import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
const names = ['Camila', 'Rodrigo', 'Sofía', 'Matías', 'Florencia', 'Nicolás', 'Valentina', 'Agustín', 'Mariana', 'Tomás', 'Lucía', 'Diego', 'Carolina', 'Martín'];
const cities = ['Buenos Aires', 'Bogotá', 'Lima', 'Santiago', 'Montevideo', 'Medellín', 'Quito', 'Córdoba', 'Rosario', 'CDMX', 'Mendoza', 'La Plata', 'Tucumán'];
export const SocialProofPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    time: 0
  });
  useEffect(() => {
    const triggerPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 14) + 2; // 2 to 15 minutes
      setData({
        name: randomName,
        city: randomCity,
        time: randomTime
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      triggerPopup();
      // Then set interval for subsequent popups (every 8-12 seconds)
      const interval = setInterval(() => {
        triggerPopup();
      }, Math.floor(Math.random() * 4000) + 8000);
      return () => clearInterval(interval);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  return <AnimatePresence data-id="element-413">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -50,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -50,
      scale: 0.9
    }} className="fixed bottom-6 left-6 z-50 bg-night-800 border border-night-700 shadow-2xl rounded-lg p-4 max-w-xs flex items-start gap-3" data-id="element-414">
          <div className="bg-accent-blue/20 p-2 rounded-full shrink-0" data-id="element-415">
            <ShoppingCart className="w-5 h-5 text-accent-light" data-id="element-416" />
          </div>
          <div data-id="element-417">
            <p className="text-sm text-gray-200" data-id="element-418">
              <span className="font-bold text-white" data-id="element-419">{data.name}</span> de{' '}
              {data.city} compró este libro digital
            </p>
            <p className="text-xs text-gray-400 mt-1" data-id="element-420">
              hace {data.time} minutos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
};